import { createContext, useContext, useEffect, useState } from "react";

export interface SiteContent {
  hero: {
    title_line1: string; title_line2: string; title_line3: string;
    subtitle: string; btn_primary: string; btn_secondary: string;
    image?: string;
  };
  about: {
    label: string; title_line1: string; title_italic: string; title_line3: string;
    card1_title: string; card1_text: string; card1_quote: string;
    card2_title: string; card2_text: string; card2_quote: string;
    bottom_text: string;
  };
  features: {
    label: string; title_line1: string; title_italic: string;
    items: { title: string; description: string; image?: string }[];
  };
  target: {
    badge: string; title: string; description: string;
    cards: { title: string; text: string }[];
  };
  details: {
    title: string; subtitle: string;
    wann_title: string; wann_text: string; wann_info: string;
    wo_title: string; wo_text: string; wo_info: string;
    mitwem_title: string; mitwem_text: string; mitwem_info: string;
  };
  cta: {
    image?: string;
    image_title_line1: string; image_title_line2: string; image_label: string;
    form_title: string; form_description: string; form_note: string; btn_text: string;
  };
  footer: {
    brand: string; description: string;
    instagram_url: string; facebook_url: string; linkedin_url: string;
    email: string; phone: string; location: string;
    impressum_url: string; datenschutz_url: string;
  };
}

export const ContentContext = createContext<SiteContent | null>(null);

export function ContentProvider({ children }: { children: React.ReactNode }) {
  const [content, setContent] = useState<SiteContent | null>(null);

  useEffect(() => {
    fetch("/api/content")
      .then((r) => r.json())
      .then(setContent)
      .catch(() => {});
  }, []);

  if (!content) return null;

  return (
    <ContentContext.Provider value={content}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent(): SiteContent {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used inside ContentProvider");
  return ctx;
}
